import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { Button, Loader, Invoice, InvoiceHistory, Title } from '@simplybenefits/sb-ui-library';
import { getInvoices, getInvoice, clearSelectedInvoice, clearInvoices, triggerDivisionRepayment, getCurrentInvoice, generateInvoiceSpreadsheet } from '../../actions/invoices.js';
import permissionLevel from '../../services/permissions.js';
import { getPdf } from '../../actions/master.js';
import * as dates from '@simplybenefits/sb-dates';

class Invoices extends PureComponent {
    state = {
        selectedSection: 'invoices-history',
        isCurrent: false,
        invoiceMeta: null
    };

    componentDidMount() {
        if (!this.props.currentInvoice && !this.props.selectedInvoice) {
            this.props.dispatch(getInvoices(this.props.account.accountID)); 
        } 
    }

    componentWillUnmount() {
        this.props.dispatch(clearInvoices());
    }

    componentWillReceiveProps() {
        if (!permissionLevel('Invoices', this.props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    _selectHistoryHeader = () => {
        this.setState({
            selectedSection: 'invoices-history',
            isCurrent: false,
            invoiceMeta: null
        });

        this.props.dispatch(clearSelectedInvoice());
    };

    _selectInvoice = async (invoiceMeta) => {
        this.setState({
            isCurrent: false,
            selectedSection: 'invoices-overview',
            invoiceMeta
        });

        await this.props.dispatch(getInvoice(this.props.account.accountID, invoiceMeta.invoiceNum));
    };

    _downloadInvoice = async (isDivisionSummary, selectedDivisionID) => {
        const fileName = `Simply_Benefits_Invoice_${ dates.getLocalDisplay(this.state.invoiceMeta?.dateAdded, 'MMMM_YYYY') }.pdf`;

        return await this.props.dispatch(getPdf("Invoice", fileName, { invoiceNum: this.state.invoiceMeta?.invoiceNum, accountID: this.props.account.accountID, isDivisionSummary: isDivisionSummary, selectedDivisionID }));
    };

    _downloadInvoiceSpreadsheet = async (isDivisionSummary, selectedDivisionID) => {
        const fileName = `Simply_Benefits_Invoice_${ dates.getLocalDisplay(this.state.invoiceMeta?.dateAdded, 'MMMM_YYYY') }.xlsx`;

        return await this.props.dispatch(generateInvoiceSpreadsheet(this.state.invoiceMeta.invoiceNum, this.props.account.accountID, isDivisionSummary, selectedDivisionID, fileName));
    };

    _getCurrentInvoice = async () => {
        await this.props.dispatch(getCurrentInvoice(this.props.account.accountID));

        await this.setState({
            isCurrent: true,
            selectedSection: 'invoices-overview'
        });
    };

    render() {
        const styles = {
            titleBlock: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginTop: 20
            }
        };

        const invoice = this.props.selectedInvoice || this.props.currentInvoice;

        return (
            <React.Fragment>
                <Title title="Invoices"/>
                <div style={ styles.titleBlock }>


                    {
                        this.state.selectedSection === 'invoices-overview' ?
                            <Button
                                id="view-history"
                                color="primary"
                                customStyle={{
                                    height: 50,
                                    width: 180,
                                    textTransform: "capitalize",
                                    fontSize: 16
                                }}
                                onClick={ this._selectHistoryHeader }
                            >
                                 View History
                            </Button>
                            :
                            null
                    }
                </div>

                {
                    this.state.selectedSection === 'invoices-history' ?
                        <InvoiceHistory
                            history={this.props.history}
                            selectInvoice={this._selectInvoice}
                            getCurrentInvoice={this._getCurrentInvoice} 
                        />
                        :
                        !invoice || this.props.loader?.isLoading ?
                            <Loader isContainer/>
                            :
                            <Invoice
                                isMasterSite={ true }
                                invoice={{
                                    ...invoice,
                                    meta: this.state.invoiceMeta
                                }}
                                isCurrent={ this.state.isCurrent }
                                whitelabel={ false }
                                account={ this.props.account }
                                divisions={ this.props.divisions }
                                accountClasses={ this.props.accountClasses }
                                hideOverview= { false }
                                triggerDivisionRepayment={ (...params) => this.props.dispatch(triggerDivisionRepayment(this.props.account.accountID, ...params)) }
                                downloadInvoice={ this._downloadInvoice }
                                downloadInvoiceSpreadsheet={ this._downloadInvoiceSpreadsheet }
                                loader={ this.props.loader }
                            />
                }
                <span id="invoices" />
            </React.Fragment>
        );
    }
}


Invoices.propTypes = {
    history: PropTypes.array,
    currentInvoice: PropTypes.object,
    selectedInvoice: PropTypes.object,
    accessType: PropTypes.string
};

/**
 * @param state
 * @returns {{selectedBill: null, admin: null, history: Array, currentBill: null}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    history: state.invoices.history,
    currentInvoice: state.invoices.current,
    selectedInvoice: state.invoices.selected,
    admin: state.accounts.currentAccount.admins,
    divisions: state.accounts.currentAccount.divisions,
    accountClasses: state.accounts.currentAccount.classes,
    account: state.accounts.currentAccount.meta,
    accessType: state.master.access
});

export default connect(mapStateToProps)(Invoices);